import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';

interface Props {
  isEdit?: boolean;
  loading?: boolean;
  onCancel: () => void;
}

function DocumentFormActions(props: Props) {
  const { isEdit, loading, onCancel } = props;
  const { t } = useTranslation();
  const actions = [
    <Button
      buttonText={t('cancel')}
      buttonType={ButtonTypes.secondaryOutlined}
      disabled={loading}
      fullWidth
      leftIcon="close"
      onClick={onCancel}
    />,
    <Button
      buttonText={isEdit ? t('save-changes') : t('save')}
      buttonType={ButtonTypes.primaryFilled}
      disabled={loading}
      fullWidth
      leftIcon="check"
      type="submit"
    />,
  ];
  return <ActionsRow actions={actions} />;
}

export default DocumentFormActions;
